<template>
  <div class="product-bundle">
    <InputComponent :disabled="disabled" @click.native="onClick">
      <div class="elder-input__element">
        <div class="product-bundle__default">
          <FontAwesomeIcon :icon="['far', 'cubes']" size="3x" />
          <h3>{{ productBundleLabel }}</h3>
          <p>{{ $t('productBundleHelptext') }}</p>
          <ul v-if="value" class="product-bundle__default__items">
            <li v-for="product in value" class="product-bundle__default__items--element">
              <Badge :value="product.name" />
            </li>
            <li v-if="excessiveProductLabel">
              <Badge :value="excessiveProductLabel" />
            </li>
          </ul>
        </div>
      </div>
    </InputComponent>
    <ProductSelect
      :value="value"
      @input="$ev => $emit('input', $ev)"
      :items="getProducts"
      type="modal-only"
      ref="selector"
      multiple
      hide-price
      select-all
    />
  </div>
</template>

<script>
import Badge from '@/components/Badge'
import { InputComponent } from 'vue-elder-input'
import ProductSelect from '@/components/Product/Select/Modal'
import ProductApi from '@/api/Product'

export default {
  props: {
    value: {
      type: Array,
      default: () => [],
    },
    disabled: Boolean,
  },
  computed: {
    excessiveProductLabel() {
      if (!this.value || this.value.length < 4) return
      return `+ ${this.value.length - 3}`
    },
    productBundleLabel() {
      const products = this.value || []

      if (!products || products.length === 0)
        return this.$t('createResource', { resource: this.$t('productBundle').toLowerCase() })

      return `${this.$t('productBundle')} (${products.length})`
    },
  },
  methods: {
    getProducts(filter) {
      return ProductApi.get({ filter }, { query: 'Products' })
    },
    onClick() {
      this.$emit('track', 'Bundle')
      this.$refs.selector.open()
    },
  },
  components: {
    Badge,
    InputComponent,
    ProductSelect,
  },
}
</script>

<style lang="scss"></style>
